// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import Typography from "elevate-ui/Typography";

import type { $Agent, $Team, $SiteOffice } from "flow/types";

type $Props = {
  classes: Object,
  compliance: Object,
  agent: $Agent,
  team: $Team,
  office: $SiteOffice,
};

const LicensedState = ({
  classes,
  compliance,
  agent,
  team,
  office,
}: $Props) => {
  if (compliance && compliance.footerShowLicensedState) {
    return (
      <div
        className={classNames(classes.root, "ref__footer-state-license-text")}
      >
        <Typography type="body" className={classes.text}>
          Licensed{" "}
          {displayState(
            (agent && agent.state) ||
              (team && team.state) ||
              (office && office.state)
          )}{" "}
          Real Estate Brokerage
        </Typography>
      </div>
    );
  } else {
    return null;
  }
};

const displayState = (state: string) => {
  if (!state) {
    return "";
  }
  state = state.toUpperCase();
  const STATE_NAMES = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District Of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  };
  return STATE_NAMES[state];
};

const styles = (theme) => {
  return {
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px 0",
      backgroundColor: theme.colors.primary["500"],
      textAlign: "center",
      color: theme.colors.primaryFontColor,
    },
    text: {
      color: theme.colors.primaryFontColor,
      fontSize: "14px",
      lineHeight: "18px",
    },
  };
};

export default withGlobalContext(withStyles(styles)(LicensedState));
